window.mtl = window.mtl || {};
window.mtl.alloy = (function($, mtl) {
    'use strict';

    // Initialiser factory
    var factory = {};

    // Event emitter
    var instance = {};
    var $emitter = $(instance);


    /**
     * Initialise an element with a named factory.
     */
    function initElementAs(element, as, options) {

        var fn = mtl.path.get(factory, as);
        if (fn) {
            fn(element, options || {});
        }

        else {
            console.error('Failed to initialize element as "%s": Factory function not defined', as);
        }

    }


    /**
     * Initialse an element according to it's `data-init` attribute.
     */
    function initElement(element) {

        var initStr = $(element).attr('data-init');
        if (!initStr) {
            return;
        }

        var init = mtl.lson.parseObjectOrArray(initStr);
        if (!init) {
            return;
        }

        // Specified without options: "foo, bar"
        if (Array.isArray(init)) {
            for (var i = 0, ix = init.length; i < ix; i++) {
                initElementAs(element, init[i]);
            }
        }

        // Specified with options: "foo: {enabled: true}, bar: {index: 3}"
        else {
            for (var name in init) {
                initElementAs(element, name, init[name]);
            }
        }

    }


    /**
     * Process an element and all eligible children.
     */
    function process(element) {

        $emitter.trigger('processStart', [element]);

        $(element).find('[data-init]').toArray().forEach(initElement);

        $emitter.trigger('processComplete', [element]);

    }


    // Export public API
    return $.extend(instance, {
        factory: factory,
        process: process,
        on:  $emitter.on.bind($emitter),
        off: $emitter.off.bind($emitter),
    });

}(jQuery, window.mtl));
